import Noticias from '@/views/intranet/noticias/Noticias.vue'
import NoticiaSingle from '@/views/intranet/noticia-single/NoticiaSingle.vue'

export const noticias = {
  path: '/noticias',
  name: 'Noticias',
  component: Noticias,
  meta: { requiresAuth: true },
}

export const noticiasSingle = {
  path: '/noticia/:id_noticia',
  name: 'NoticiaSingle',
  component: NoticiaSingle,
  meta: { requiresAuth: true }
}
